import React from "react";
import { Button, Input } from "@revvsales/components";

class ConfigureColumns extends React.Component {
  state = {
    manageColumns: [],
  };

  componentDidMount() {
    const { manageColumns, columnDefs } = this.props;
    this._setColumnFlags(manageColumns, columnDefs);
  }

  componentDidUpdate(prevProps) {
    const { manageColumns, columnDefs } = this.props;
    if (
      prevProps.manageColumns !== manageColumns &&
      prevProps.columnDefs !== columnDefs
    ) {
      this._setColumnFlags(manageColumns, columnDefs);
    }
  }

  _setColumnFlags = (columns, columnDefs) => {
    if (columns && Array.isArray(columns)) {
      const manageColumns = columnDefs
        .filter(column => column.type)
        .map(column => {
          const colIndex = columns.findIndex(col => col.id === column.field);
          const check = colIndex > -1 ? columns[colIndex].isChecked : false;
          return {
            id: column.field,
            name: column.headerName,
            isChecked: check,
          };
        });
      this.setState({ manageColumns });
    }
  };

  _returnTitle = () => {
    const headers = ["Columns", "Visible"];
    return headers.map(header => (
      <div className="aggridvisibilityctrl-header-title" key={header}>
        {header}
      </div>
    ));
  };

  _returnColumnList = () => {
    const { manageColumns } = this.state;
    return manageColumns.map(column => (
      <div className="aggridvisibilityctrl-row" key={column.id}>
        <div className="aggridvisibilityctrl-row-roles">{column.name}</div>
        <div className="aggridvisibilityctrl-row-roles">
          <Input
            checked={column.isChecked}
            name="role"
            onChange={event => this._updateColumnFlag(event, column.id)}
            type="checkbox"
            value=""
            data-test="configurecolumns-input"
          />
        </div>
      </div>
    ));
  };

  _updateColumnFlag = (event, columnID) => {
    const { manageColumns } = this.state;
    const column = manageColumns.find(col => col.id === columnID);
    if (column) column.isChecked = event.target.checked;
    this.setState({ manageColumns });
  };

  _reject = () => {
    this.setState({ manageColumns: [] });
    this.props.closePopUp();
  };

  _submit = () => {
    const { handleColumnManage } = this.props;
    const { manageColumns } = this.state;
    handleColumnManage(manageColumns.filter(column => column.isChecked));
    this.props.closePopUp();
  };

  render() {
    return (
      <div className="revv-modal-content">
        <div className="revv-modal-contenttitle">
          Manage columns visibility in document
          <div className="aggridvisibilityctrl-description">
            You can manage the visibility of the columns that shows up in
            document
          </div>
        </div>
        <div className="aggridvisibilityctrl-header doc-column-management">
          {this._returnTitle()}
        </div>
        <div className="aggridvisibilityctrl-list doc-column-management">
          {this._returnColumnList()}
        </div>
        <div className="revv-modal-footer">
          <div className="revv-modal-footerbtns">
            <Button
              className="btn-transparent"
              onClick={this._reject}
              data-test="configurecolumns-discard-btn">
              Discard
            </Button>
            <Button
              onClick={this._submit}
              data-test="configurecolumns-save-btn">
              Save
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ConfigureColumns;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/ConfigureColumns.js